$(document).ready(function() {

	$('#new-hires--search-input').on('focus',function(e) {

		var tagValue = $(this).val()

		if ( tagValue ) {
			searchNewHires(tagValue);
		}

	});

	if ( $('.new-hires--dropdown').length > 0 ) {

		$('.new-hires--dropdown').selectric({
			maxHeight: 300
		}).on('change', function(e, element, selectric) {
			e.preventDefault();
			filterNewHires();
		});

	}

	$('#new-hires--search-input').on('focus',function(e) {

		var tagValue = $(this).val()

		if ( tagValue ) {
			$('.new-hires--dropdown').val("").selectric('refresh');
			searchNewHires(tagValue);
		} else {
			$('.new-hires--item').removeClass('is-hiding');
			$('.new-hires--dropdown').val("").selectric('refresh');
		}

	});


	$('#new-hires--search-input').keyup(function( event ) {

		var tagValue = $(this).val().toLowerCase();

		if ( tagValue ) {
			$('.new-hires--dropdown').val("").selectric('refresh');
			searchNewHires(tagValue);
		} else {
			$('.new-hires--item').removeClass('is-hiding');
			$('.new-hires--dropdown').val("").selectric('refresh');
		}

	});

	function filterNewHires() {

    	$('#new-hires--search-input').val("");

    	var classesArray = [];

		$('.new-hires--dropdown').each(function(){

			var selectClass = $(this).val();

			if (selectClass) {
				classesArray.push(selectClass);
			}

		});

		if (classesArray.length > 0) {

			var newHiresItems = $('.new-hires--item');

			newHiresItems.each(function() {

				var shouldHide = false;
				var newHiresItem  = $(this);

				$.each(classesArray, function(i,val) {

				  if ( !newHiresItem.hasClass(val) ) {
				    shouldHide = true;
				  }

				});

				if (shouldHide) {
					$(this).addClass('is-hiding');
				} else {
					$(this).removeClass('is-hiding');
				};

			});

		} else {

			$('.new-hires--item').removeClass('is-hiding');

		}

	}

	function searchNewHires( value ) {

    var tagValue   = value;
    var newHires = $('.new-hires--item');

	if (tagValue && tagValue.length > 2) {

		newHires.each(function() {

			var shouldHide  = false;
			var newHireItem = $(this);
    		var tags        = newHireItem.data('searchtags');

			if ( !tags.includes(tagValue) ) {
				shouldHide = true;
			}

			if (shouldHide) {
				$(this).addClass('is-hiding');
			} else {
				$(this).removeClass('is-hiding');
			};

		});

	} else {

		newHires.removeClass('is-hiding');

    }

  }

});
